import React  from 'react';
import {
  Button,
  ButtonContainer,
  Fieldset,
  Layout,
  Modal,
  Spinner,
} from '@vwfs-bronson/bronson-react';
import { Formik, Field, Form } from 'formik'
import * as Yup from "yup";
import { Output } from '../../../Text';
import { TextField } from '../../../formik';
import { sendTan, tanValidation } from '../../../services/api/mailValidation/mailValidation';
import { Analytics } from '../../../services/analytics';

const COOLDOWN_TIMER = 60

const EmailValidationModal = ({ ...props }) => {
  const { transactionId, email, visible, onClose, onValidation, onSuccess, onError, onVerify } = props;
  const [isLoading, setIsLoading] = React.useState(false);
  const [counter, setCounter] = React.useState(0);

  let setFormErrors;

  const initialValues = {
    code: '',
  };

  const ValidationSchema = Yup.object().shape({
    code: Yup.string().required(Output.resolve('generic.errors.M001_mandatoryFields')),
  });
  const pageName = "Summary page";
  const defaultTrackingData = {
    [Analytics.keys.pageName()]: pageName,
  };

  const newTan = async () => {
    try {
      setIsLoading(true);
      await sendTan(transactionId);
      resetCounter();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false)
      if (onError) {
        onError(error);
      }
    }
  };

  const trackInvalidCode = () => {
    const pageData = {
      [Analytics.keys.viewChange()]: 'Email check - wrong code',
      [Analytics.keys.eventType(0)]: 'pageview',
      [Analytics.keys.eventAction(0)]: 'Success',
      [Analytics.keys.linkInformation(0)]: 'Email check - wrong code',
    }
    Analytics.setTrackingData({ ...defaultTrackingData, ...pageData });
    Analytics.trackPage()
  };

  const handleErrorSubmit = error => {
    const status = error?.response?.status?.toString()
    switch (status) {
      case '400':
        setFormErrors({ code: Output.resolve('emailValidationModal.invalidTan') });
        break
      default:
        onError(error);
    }
  };

  const handleSubmit = async values => {
    try {
      setIsLoading(true)
      if (onValidation) {
        onValidation();
      }
      const response = await tanValidation(values?.code, transactionId)
      setIsLoading(false)
      if (onSuccess) {
        onSuccess(response);
      }
    } catch (error) {
      trackInvalidCode()
      setIsLoading(false)
      handleErrorSubmit(error)
    }
  }

  const resetCounter = async () => {
    setCounter(COOLDOWN_TIMER)
  }

  React.useEffect(() => {
    if (counter > 0) {
      setTimeout(async () => {
        await setCounter(counter - 1)
      }, 1000)
    }
  }, [counter])

  const buildCounter = () => {
    return `${counter}${Output.resolve('emailValidationModal.timeUnit')}`
  }

  return (
    <>
      {isLoading && <Spinner center fullPage />}
      <Modal
        title={Output.resolve('emailValidationModal.title')}
        onClose={() => {
          if (onClose) {
            onClose()
          }
        }}
        shown={visible}
        stretch
      >
        <Layout className="u-mb-large">
          <Layout.Item default="1/1">
            {Output.templateWithValues(Output.resolve('emailValidationModal.text'), {
              email,
            })}
          </Layout.Item>
          <Layout.Item default="1/1">
            <Formik
              initialValues={initialValues}
              validationSchema={ValidationSchema}
              onSubmit={e => handleSubmit(e)}
              render={formProps => {
                const { setErrors, setFieldValue } = formProps;
                setFormErrors = setErrors
                return (
                  <Form id="data-protection-form">
                    <Fieldset.Row>
                      <Layout center>
                        <Layout.Item default="1/2" className="u-mt">
                          <Field
                            name="code"
                            label={Output.resolve('emailValidationModal.code')}
                            component={TextField}
                            customOnChange={(e)=>{
                              setFieldValue("code", e.target.value.trim())
                            }}
                          />
                        </Layout.Item>
                      </Layout>
                    </Fieldset.Row>
                    <Fieldset.Row className="u-text-center">
                      <Layout center>
                        <Layout.Item default="1/1">
                          <ButtonContainer center>
                            <Button
                              className="u-text-center"
                              type="submit"
                            >
                              {Output.resolve('emailValidationModal.button')}
                            </Button>
                          </ButtonContainer>
                        </Layout.Item>
                        {counter > 0 && (
                          <Layout.Item
                            default="1/1"
                            className="u-mt u-text-center"
                          >
                            {buildCounter()}
                          </Layout.Item>
                        )}
                      </Layout>
                    </Fieldset.Row>
                  </Form>
                )
              }}
            />
          </Layout.Item>
          <Layout.Item default="1/1">
            <Layout>
              <Layout.Item default="1/2" className="u-text-left u-mt-large">
                <Button
                  onClick={() => {
                    if (onVerify) {
                      onVerify()
                    }
                  }}
                  link
                >
                  {Output.resolve('emailValidationModal.verifyLink')}
                </Button>
              </Layout.Item>
              <Layout.Item default="1/2" className="u-text-right u-mt-large">
                <Button
                  onClick={() => {
                    newTan()
                  }}
                  link
                  disabled={counter > 0}
                >
                  {Output.resolve('emailValidationModal.resendLink')}
                </Button>
              </Layout.Item>
            </Layout>
          </Layout.Item>
        </Layout>
      </Modal>
    </>
  )
}

export default EmailValidationModal;
